export const searchItem = [
    { id: 1, label: "Asset ID", value: "trackingid" },
    { id: 2, label: "SITE ID", value: "siteid" },
    { id: 3, label: "gNB ID", value: "gnodeb_id" }
]